import React, { useEffect, useState } from 'react'
import AddAddendum from './AddAddendum';
import DropdownValueHandler from '../../../../../../../shared/SuperSearch/DropdownValueHandler';
import { useSelector } from 'react-redux';
import FormatPhoneNumber from '../../../../../../../../utils/FormatPhoneNumber';
import { ServerRequestPublic } from '../../../../../../../../utils/ServerDataRequest';
import { enumUtil } from '../../../../../../../../utils/Enum';
import { FindFirstChild, FindSecondChild } from '../../../../../../../../utils/FindMenuOption';
import isNull from '../../../../../../../../utils/NullChecking';
import { isSignedOrToBeCoSigned } from './utils';
import CustomUseRef from '../../../../../../../shared/DropDown/CustomUseRef';
import ViewTranscript from '../EncounterDetails/ViewTranscript';
import NotificationHandler from '../../../../../../../../utils/NotificationHandler';
import { saveAs } from "file-saver"
import Loader from '../../../../../../../shared/Loader/Loader';

const SOAPPreview = ({ data, searchValue, searchParam, handleClosePreview, printoutSelectDataModal, setPrintoutSelectDataModal, isGroupNote, ...props }) => {

    console.log('isGroupNote', isGroupNote);

    const [addendumModal, setAddendumModal] = useState(false);
    const visitTypes = useSelector(state => state.GeneralDropDownsReducer.EncounterType)
    let { dataExist, divClaimLinking, mainServiceLineModal, handleCreateClaim, handleViewClaim } = props;

    let isSignEditAllowed = FindFirstChild('Patient', 'Sign Encounters')?.IsAdd;
    let isSaveEditAllowed = FindFirstChild('Patient', 'Encounter')?.IsAdd;
    let isSuperbillEditAllowed = FindFirstChild('Patient', 'Add SuperBill')?.IsAdd;
    let isClaimViewAllowed = FindSecondChild('Billing', 'Claims', 'Claims')?.ISView
    let isCreateClaimEditAllowed = FindFirstChild('Patient', 'Create Claim For SuperBill')?.IsAdd;

    const { canCoSign, coSignItemData, coSignList, setSaveEncounterCoSignData, handleSign, isToBeCoSignedStatus } = props?.coSignProps || {};

    console.log("initialDataEnccoSignListPreview", props?.coSignProps, coSignList, isToBeCoSignedStatus)

    const handleAddAddendum = () => {
        console.log("handleAddAddendum")
        if (!isSaveEditAllowed) return;
        setAddendumModal(true);
    }
    console.log("SOAPPreviewdata", data)
    const handleEditSuperbill = () => {
        if (!isSuperbillEditAllowed) return;
        let element = document?.getElementById(`SuperBill-${data?.Data?.EncounterID}`)
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
            props?.setIsProcedureEdit(true);
        }
    }
    let noValExistTextNA = <p className="fst-italic light-clrs text">N/A</p>;
    const signed = coSignList?.filter(it => [true, "true"].includes(it.isCoSigned));
    const pending = coSignList?.filter(it => [false, "false"].includes(it.isCoSigned));


    //
    const [subMenuActive, setSubMenuActive] = useState(false);
    const handleSubActiveMenu = (e) => {
        setSubMenuActive(!subMenuActive)
        e.stopPropagation();
    }

    const closeDropdown = () => {
        setSubMenuActive(false)
    };

    const [viewTranscript, setViewTranscript] = useState(false)
    const handleViewTranscript = () => {
        console.log("Clicked");
        setViewTranscript(true)
    }
    const CloseViewTranscript = () => {
        setViewTranscript(false)
    }
    let viewTranscriptPopup
    if (viewTranscript) {
        viewTranscriptPopup = <ViewTranscript viewTranscript={viewTranscript} CloseViewTranscript={CloseViewTranscript} encounterID={data?.Data?.EncounterID} />
    }
    const showTranscript =
        data?.Data?.IsAIGenerated === "true" &&
        !isNull(data?.Data?.ClinicalAINoteJobsID);

    const showSubMenuButton =
        showTranscript;

    const [isLoading, setIsLoading] = useState(false);
    const API_URL_AINoteWorkflows = enumUtil.controller.AINoteWorkflows
    const handleDownloadAudioTranscript = () => {
        setIsLoading(true)
        ServerRequestPublic(API_URL_AINoteWorkflows + "/DownloadEncounterFiles?EncounterID=" + data?.Data?.EncounterID,
            'GET', '', "Download", '')
            .then((response) => {
                let blob = new Blob([response]);
                saveAs(blob, "AudioTranscript" + ".zip");
                setIsLoading(false)
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            })
    }
    return (
        <>
            {isLoading ? <Loader /> : null}
            <AddAddendum addendumModal={addendumModal} setAddendumModal={setAddendumModal} saveAddendumData={props?.saveAddendumData} setSaveAddendumData={props?.setSaveAddendumData} getSaveData={props?.getSaveData} />
            <div class="row m-0 row-gap-5 align-items-end g-0 encounter-edit-mode ar-size-adjustemnt p-2">
                <div class="col-md-5">
                    <div class="row m-0 align-items-end">
                        <div class="col-md-2 px-0">
                            <p class="heading">Patient:</p>
                        </div>
                        <div class="col-md-10 pe-0">
                            <p class="text d-flex align-items-center gap-1">{data?.Data?.PatientName} <span className='ar-light-color d-flex gap-1 align-items-center'>
                                <span>{data?.Data?.DOB}</span><span> {data?.Data?.Age ? `(${data?.Data?.Age})` : ''} </span> <span>{data?.Data?.Gender}</span></span>
                                {(!data?.Data?.PatientName &&
                                    !data?.Data?.DOB &&
                                    !data?.Data?.Age &&
                                    !data?.Data?.Gender) && noValExistTextNA}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="ar-md-3-5">
                    <div class="row m-0 align-items-end">
                        <div class="col-md-4 px-0">
                            <p class="heading">Provider:</p>
                        </div>
                        <div class="col-md-8 pe-0">
                            <p class="text">{searchValue?.SeenBy || noValExistTextNA}</p>
                        </div>
                    </div>
                </div>

                <div class="ar-md-3-5">
                    <div class="row m-0 align-items-end">
                        <div class="col-md-4 px-0">
                            <p class="heading">Encounter Date:</p>
                        </div>
                        <div class="col-md-8 pe-0">
                            <p class="text">{searchParam?.EncounterDate || noValExistTextNA}</p>
                        </div>
                    </div>
                </div>

                <div class="col-md-5">
                    <div class="row m-0 align-items-end">
                        <div class="col-md-2 px-0">
                            <p class="heading">Account #</p>
                        </div>
                        <div class="col-md-10 pe-0">
                            <p class="text">{data?.Data?.AccountNumber || noValExistTextNA}</p>
                        </div>
                    </div>
                </div>

                <div class="ar-md-3-5">
                    <div class="row m-0 align-items-end">
                        <div class="col-md-4 px-0">
                            <p class="heading">Location:</p>
                        </div>
                        <div class="col-md-8 pe-0">
                            <p class="text">{searchValue?.Facility || noValExistTextNA}</p>
                        </div>
                    </div>
                </div>

                <div class="ar-md-3-5">
                    <div class="row m-0 align-items-end">
                        <div class="col-md-4 text-nowrap px-0">
                            <p class="heading">Encounter Type:</p>
                        </div>
                        <div class="col-md-8 pe-0">
                            <p class="text">{DropdownValueHandler(visitTypes, searchParam?.EncounterType) || noValExistTextNA}</p>
                        </div>
                    </div>
                </div>

                <div class="col-md-5">
                    <div class="row m-0 align-items-end">
                        <div class="col-md-2 px-0">
                            <p class="heading">Cell Phone:</p>
                        </div>
                        <div class="col-md-10 pe-0">
                            <p class="text">{FormatPhoneNumber(data?.Data?.MobileNumber) || noValExistTextNA}</p>
                        </div>
                    </div>
                </div>

                <div class="ar-md-3-5">
                    <div class="row m-0 align-items-end">
                        <div class="col-md-4 px-0">
                            <p class="heading">Note Type:</p>
                        </div>
                        <div class="col-md-8 pe-0">
                            <p class="text validation_message text-nowrap" title={searchValue?.NoteType}>{searchValue?.NoteType || noValExistTextNA}</p>
                        </div>
                    </div>
                </div>

                <div class="ar-md-3-5">
                    <div class="row m-0 align-items-end">
                        <div class="col-md-4 px-0">
                            <p class="heading">Last Visit: </p>
                        </div>
                        <div class="col-md-8 pe-0">
                            <p className='text'>{data?.Data?.LastVisit || noValExistTextNA}</p>
                        </div>

                    </div>
                </div>

            </div>

            <div className="mt-1 d-flex justify-content-end align-items-center px-2  py-1 br-bottom-1 za_br_light">
                {/* <div className={`signature-prview-box ${!(isSignedOrToBeCoSigned.includes(data?.Data?.EncounterStatus)) ? 'NO-Sign' : ''} `}>
                    {isSignedOrToBeCoSigned.includes(data?.Data?.EncounterStatus) ?
                        <>
                            <SignImagePreview BucketPath={data?.Data?.SignaturePath} />
                        </> : <> </>}
                </div> */}
                {/* {isSignedOrToBeCoSigned.includes(data?.Data?.EncounterStatus) ?
                    <div className='br-top-1 br-bottom-1  br-clr preview-footer d-flex'>
                        <p className='heading heading_ext d-flex align-items-center gap-2'>Electronically Signed by/date:<span className='text text_color'>{data?.Data?.ProviderSignBy || 'N/A'} on {data?.Data?.ProviderSignatureDate || 'N/A'}</span></p>
                        {signed?.map(sign => 
                            <p className='heading heading_ext d-flex align-items-center gap-2'>Electronically Signed by/date:<span className='text text_color'>{sign?.Data?.ProviderSignBy || 'N/A'} on {sign?.SignatureDate || 'N/A'}</span></p>
                        )}
                    </div>
                    :
                    null} */}
                {/* <div className='preview-footer'>
                        <p className="text ar-light-color">Electronically Signed by: {data?.Data?.ProviderSignBy || 'N/A'} on {data?.Data?.ProviderSignatureDate || 'N/A'}</p>
                    </div> */}

                <div class="position-relative ar-encounter-preview-btn-bar">
                    <div className="d-flex align-items-center gap-2">
                        <div className="d-flex align-items-center gap-1">

                            {(searchValue?.EncounterStatus === 'Signed' || data?.Data?.EncounterStatus === 'Signed') ?
                                (coSignList?.length > 0 ?
                                    <></> :
                                    <p className='Paid heading font-m ar-status-clm'>Signed</p>) :
                                searchValue?.EncounterStatus === 'In Progress' ?
                                    <p className='Blue-Status heading font-m ar-status-clm'>In Progress</p> :
                                    searchValue?.EncounterStatus === 'Ready for Review' ?
                                        <p className='In-Review heading font-m ar-status-clm'>Ready for Review</p> :
                                        ['Unsigned', 'UnSigned'].includes(searchValue?.EncounterStatus) &&
                                        <p className='Not-Signed heading font-m ar-status-clm'>Unsigned</p>}

                            {/* // Co Sign Status Tooltip //// Co Sign ////Sign//// */}
                            {(isSignedOrToBeCoSigned.includes(data?.Data?.EncounterStatus) && coSignList?.length > 0) ?
                                <div className="app_tooltip bottom grossary description claimStatus">
                                    {data?.Data?.EncounterStatus === 'Signed' ?
                                        <p className='Paid heading font-m ar-status-clm'>{data?.Data?.EncounterStatus}</p> :
                                        <p className='pill Transfer-to-Insurance'>{data?.Data?.EncounterStatus}</p>}
                                    <p className="tool_tip start-0">
                                        <span className='text text-light multi-line-truncate text-wrap overflow-hidden fs-12'>
                                            {signed?.length > 0 ? (
                                                <>
                                                    Co-signed by: <br />
                                                    {signed.map(it => it.ProviderName).join(", ")} <br />
                                                    {pending?.length > 0 && (
                                                        <>
                                                            Pending: <br />
                                                            {pending.map(it => it.ProviderName).join(", ")}
                                                        </>
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    To be co-signed by: <br />
                                                    {pending.map(it => it.ProviderName).join(", ")}
                                                </>
                                            )}
                                        </span>
                                    </p>
                                </div> : <></>}


                            <div className='d-flex align-items-center cursor-pointer ps-1 br-left-1 br-clr-light text-nowrap'>
                                {!isNull(data?.Data?.EncounterID) && !isGroupNote &&
                                    (!isNull(data?.Data?.ClaimID) ?
                                        (<div className={`d-flex align-items-center cursor-pointer ${isClaimViewAllowed ? '' : 'disable'}`}>
                                            <p className='heading fs-11 validate-color' onClick={handleViewClaim}>View Claim</p>
                                            <i className='icon-enrollment fs-13 lh-9'></i>
                                        </div>) :
                                        <div className={`d-flex align-items-center cursor-pointer ${isCreateClaimEditAllowed ? '' : 'disable'}`}>
                                            {(dataExist ?
                                                (divClaimLinking) :
                                                (
                                                    mainServiceLineModal?.some(serviceLine => !isNull(serviceLine.SuperBillID)) ?
                                                        <div className='d-flex align-items-center cursor-pointer' onClick={handleCreateClaim}>
                                                            <p className={`heading fs-11 validate-color`}>Create Claim</p>
                                                            <i className='icon-enrollment fs-13 lh-9'></i>
                                                        </div>
                                                        :
                                                        <></>

                                                ))}
                                        </div>
                                    )}
                            </div>

                            {/* <div className='d-flex align-items-center cursor-pointer ps-1 br-left-1 br-clr-light text-nowrap'>
                                <div className={`d-flex align-items-center cursor-pointer`}>
                                    <p className='heading fs-11 validate-color'>View Claim</p>
                                    <i className='icon-enrollment fs-13 lh-9'></i>
                                </div>
                                <div className={`d-flex align-items-center cursor-pointer`}>
                                    <div className='d-flex align-items-center cursor-pointer'>
                                        <p className={`heading fs-11 validate-color`}>Create Claim</p>
                                        <i className='icon-enrollment fs-13 lh-9'></i>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                        {canCoSign &&
                            <button className={`btn rounded btn-orange ${isSignEditAllowed ? '' : 'disabled'}`} onClick={handleSign}>Co-Sign</button>}
                        {isSignedOrToBeCoSigned.includes(searchParam?.EncounterStatus) && !isGroupNote &&
                            <button className={`btn btn-light px-10 rounded h-100 lh-14 py-3px ${isSuperbillEditAllowed ?
                                '' : 'disabled'
                                }`} onClick={handleEditSuperbill}>Edit Superbill</button>
                        }
                        {isSignedOrToBeCoSigned.includes(data?.Data?.EncounterStatus) ?
                            (!isGroupNote &&
                                <button className={`btn btn-light px-10 rounded h-100 lh-14 py-3px ${isSaveEditAllowed ? '' : 'disabled'}`} onClick={handleAddAddendum}>
                                    Add Addendum
                                </button>
                            ) :
                            <button className={`btn btn-light px-10 rounded h-100 lh-14 py-3px ${isSaveEditAllowed ? '' : 'disable'}`} onClick={handleClosePreview}>
                                Back to Edit
                            </button>

                        }
                        {/* {isGroupNote ? null : */}
                        <span class={`icon-Group-1000002858 fs-20 br-clr ps-2 br-left-0-5 ${isSignedOrToBeCoSigned.includes(data?.Data?.EncounterStatus) ? '' : ' br-left-1'}`} onClick={() => setPrintoutSelectDataModal(!printoutSelectDataModal)}>
                            <span class="path1"></span><span class="path2"></span>
                        </span>
                        {showSubMenuButton && (
                            <div className="position-relative hk-opt-bar br-clr br-left-1 ps-2px">
                                <button className="btn-icon-transparent claim_submenu lh-10 border-0 p-0" onClick={handleSubActiveMenu}><i class="icon-dots-menu lh-20"></i>
                                    {<CustomUseRef onClose={closeDropdown} IsActivePtPayments={subMenuActive}>
                                        {subMenuActive === true ?
                                            <>
                                                {showTranscript && (
                                                    <div className='claims-TabHeader__right__submenu right-7 top-100-5 active user-select-none w-202px'>
                                                        <div className="itemList py-2">
                                                            <div className="itemList__item" onClick={handleViewTranscript}>View Transcript</div>
                                                            <div className="itemList__item" onClick={handleDownloadAudioTranscript}>Download Audio & Transcript</div>
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                            : null
                                        }
                                    </CustomUseRef>}
                                </button>
                            </div>
                        )}

                        {/* } */}
                    </div>
                    {viewTranscriptPopup}
                </div>
            </div>
        </>
    )
}

export default SOAPPreview

const SignImagePreview = ({ BucketPath, ...props }) => {
    const API_URL_Wasabi = enumUtil.controller.Wasabi;
    const [imgFile, setImgFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (BucketPath) {
            setIsLoading(true);
            ServerRequestPublic(
                API_URL_Wasabi + "/DownloadFile",
                "post",
                { BucketPath },
                "Download"
            )
                .then((response) => {
                    setIsLoading(false);

                    if (["application/png", "application/jpg", "application/jpeg", "application/tiff"].includes(response.type)) {
                        const blob = response;
                        const objectURL = URL.createObjectURL(blob);
                        setImgFile(objectURL);
                    }
                })
                .catch(() => {
                    setImgFile(null);
                    setIsLoading(false)
                });
        }
    }, [BucketPath]);

    //   if (!imgFile) return null;
    return (
        <>
            {isLoading ?
                <div className="ar-small-loader last_loader">
                    <div className="circle circle1"></div>
                    <div className="circle circle2"></div>
                </div>
                :
                <img
                    src={imgFile}
                    style={{ maxHeight: "40px" }}
                    alt="Uploaded preview"
                />
            }
        </>

    );
};